import React, { useCallback } from 'react';
import { noop } from 'js/utils/methods.util';
import { useEffectOnce } from 'js/hooks/useEffectOnce';
import { ManagedPopup } from 'js/components/common/Popup';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { TwoFactorAuthentication } from './components/TwoFactorAuthentication';

import style from './TwoFactorAuthenticationPopup.scss';

const popupClassNames = {
    inner: style.popupInner
};

const layerClassNames = {
    layout: style.layout
};

export const TwoFactorAuthenticationPopup = ({
    id,
    title,
    templateId,
    controls,
    onSuccess,
    resendHandler,
    onClose,
    onCancel = noop,
    initiator,
    showTrustDeviceOption = false
}) => {
    const closePopup = useCombinedOnClose(onClose, id);
    const cancelAndClose = useCallback(() => {
        if (initiator) {
            publicEventsAPIService.trigger('2fa-popup-closed', initiator);
        }

        closePopup();
        onCancel();
    }, [closePopup, onCancel, initiator]);

    useEffectOnce(() => {
        if (initiator) {
            publicEventsAPIService.trigger('2fa-popup-opened', initiator);
        }
    }, [initiator]);

    return (
        <ManagedPopup
            id={id}
            controls={controls}
            onClose={cancelAndClose}
            className={style.container}
            classNames={popupClassNames}
            layerClassNames={layerClassNames}
        >
            <TwoFactorAuthentication
                title={title}
                onClose={closePopup}
                onSuccess={onSuccess}
                templateId={templateId}
                onCancel={cancelAndClose}
                resendHandler={resendHandler}
                showTrustDeviceOption={showTrustDeviceOption}
            />
        </ManagedPopup>
    );
};
